import { Inertia } from '@inertiajs/inertia';
import { computed, nextTick, reactive, watchEffect } from 'vue';

const state = reactive({
  subnav: [],
  title: '',
});

const subnav = computed({
  get: () => state.subnav,
  set: value => nextTick(() => state.subnav = value),
});

const title = computed({
  get: () => state.title,
  set: value => nextTick(() => state.title = value),
});

let initial = true;

Inertia.on('navigate', () => {
  if (initial) return initial = false;
  state.subnav = [];
  state.title = '';
});

watchEffect(() => {
  document.title = title.value;
});

function assign(value) {
  nextTick(() => {
    Object.keys(value).forEach(key => {
      if (key in state) state[key] = value[key];
    });
  });
}

export default function useMeta() {
  return {
    assign,
    subnav,
    title,
  }
}
